export const ATHENA_REALTIME_QUERY_START = 'action.athena_realtime.run_query';
export const ATHENA_REALTIME_QUERY_FINISHED = 'action.athena_realtime.run_query.finished';
export const UNLOAD = 'action.athena_realtime.run_query.unload';

export const queryStart = () => ({ type: ATHENA_REALTIME_QUERY_START });
export const unload = () => ({ type: UNLOAD });
export const queryFinished = data => ({ type: ATHENA_REALTIME_QUERY_FINISHED, data });
